"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssignationOfferDriverPrice = getAssignationOfferDriverPrice;
const getBasePriceFromTotalPrice_1 = require("../getBasePriceFromTotalPrice");
// TODO: fix type
// export function getAssignationOfferDriverPrice(offer: { totalPrice: { total: number; fee: number }; subsidy?: number }) {
function getAssignationOfferDriverPrice(offer) {
    const subsidy = offer.subsidy ?? 0;
    return (0, getBasePriceFromTotalPrice_1.getBasePriceFromTotalPrice)(offer.totalPrice) + subsidy;
}
//# sourceMappingURL=getAssignationOfferDriverPrice.js.map